import React from "react";
import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Grid } from "@mui/material";
import MenuCard from "./MenuCard";

import { LogoCard } from "../../components/common/PartnersLogos";
import { partnersLogos } from "../../constants/partnersLogos";

const HomePageContainer = styled("div")({
  width: "100%",
  justifyContent: "center",
  alignItems: "center",
  padding: "2rem",
});

const HomeTitleContainer = styled("div")({
  justifyContent: "left",
  textAlign: "left",
  width: "100%",
  paddingBottom: "1rem",
});

const Home: React.FC = () => {
  return (
    <HomePageContainer>
      <HomeTitleContainer>
        <Typography variant="h1">
          <em>Te Tauira Matapae Pūmate Rū i Aotearoa • New Zealand National Seismic Hazard Model</em>
        </Typography>
        <Typography variant="h5">
          <em>an Earth Sciences New Zealand led research programme</em>
        </Typography>
      </HomeTitleContainer>

      <Grid container spacing={3} columns={{ sm: 6, md: 8, lg: 12 }} sx={{ paddingBottom: "2rem" }}>
        <MenuCard
          title="About"
          text="Background Information."
          img="/images/NSHM_logos/NSHM_Update.svg"
          url="/About"
          objectFit="contain"
          imgPaddingX={2}
        />
        <MenuCard
          title="Curves and Spectra"
          text="Site hazard and UHS plots."
          img="/images/SpectralAccelChart.png"
          url="/Hazardcurves"
        />
        <MenuCard title="Hazard Maps" text="Hazard levels across NZ." img="images/hazard_map.jpeg" url="/HazardMaps" />
        <MenuCard
          title="Rupture Explorer"
          text="Filter and animate ruptures."
          img="/images/rupture_explorer_thumb.png"
          url="/RuptureMap"
        />
        <MenuCard title="Disaggregations" text="Source breakdowns." img="/images/disagg2.png" url="/Disaggs" />
        <MenuCard
          title="Science Reports"
          text="Model reports and datasets."
          img="/images/open_books.jpg"
          url="/Resources/ScienceReports"
        />
      </Grid>

      <Grid container spacing={3} columns={{ sm: 6, md: 8, lg: 12 }}>
        <Grid size={{ xs: 12 }}>
          <LogoCard title="E mahi ana me" text="In collaboration with" logos={partnersLogos} />
        </Grid>
      </Grid>
    </HomePageContainer>
  );
};

export default Home;
